import { render } from "./InfoBanner.vue?vue&type=template&id=9efba382&scoped=true"
import script from "./InfoBanner.vue?vue&type=script&lang=js"
export * from "./InfoBanner.vue?vue&type=script&lang=js"

import "./InfoBanner.vue?vue&type=style&index=0&id=9efba382&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src407580977/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9efba382"]])

export default __exports__